import apiConfig from "../utils/api";

export const notificationTemplates = {
  aprobarSolicitud: (data) => ({
    subject: `Aprobar Solicitud ${data.numeroSolicitud} C.Costo ${data.codigoCentro}`,
    html: `
      <h1>Se solicita revisar los equipos de la Solicitud ${data.numeroSolicitud} de ${data.tipoSolicitud} en el centro de costo ${data.codigoCentro}!</h1>
      <p>${data.observacionAd || ""}.</p>  
      <p>
        Puedes ver la solicitud completa 
        <a href="${apiConfig.dev.URL_AMBIENTE}/Solicitudes" target="_blank">
          aquí
        </a>
      </p>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  solicitudAprobada: (data) => ({
    subject: `Solicitud ${data.numeroSolicitud} Aprobada`,
    html: `
      <h1>La solicitud ${data.numeroSolicitud} de ${data.tipoSolicitud} fue Aprobada.</h1>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  autorizarAsignacion: (data) => ({
    subject: `Autorizar Asignación Solicitud ${data.numeroSolicitud}`,
    html: `
      <h1>El equipo de logística a enviado Asignaciones de Equipos para su aprobación.</h1>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  equipoAutorizado: (data) => ({
    subject: `Equipo Autorizado Solicitud ${data.numeroSolicitud}`,
    html: `
      <h1>El Proyecto a Autorizado un equipos Asignados para comenzar su implementación.</h1>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),
  
  nuevoTicket: (data) => ({
    subject: `Implementación Equipo  ${data.numeroInterno}`,
    html: `
      <h1>El Proyecto a Autorizado un equipo ${data.numeroInterno} serie ${data.serie} patente ${data.patente} para comenzar su implementación, proyecto ${data.codigo} - ${data.nombreProyecto} - ${data.ubicacion}</h1>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  ticketExpeditor: (data) => ({
    subject: `Carpeta Equipo ${data.numeroCarpeta}`,
    html: `
      <h1>Equipo ${data.codigoEquipo} serie ${data.serie} patente ${data.patente} esta disponible para comenzar su revisión, carpeta ${data.numeroCarpeta}</h1>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

salidaObra: (data) => ({
  subject: `Salida Equipo ${data.codigo}`,
  html: `
    <h1>Equipo ${data.codigo} serie ${data.serie} patente ${data.patente} salió de la obra en la fecha ${data.fechaEntrega}. Número de ticket: ${data.numTicket}</h1>
    <p>Gracias por usar Logitrack.</p>
    <strong>Equipo de Soporte</strong>
  `
}),

  traspasoCC: (data) => ({
    subject: `Traspaso CC — Equipo ${data.codigo} (Ticket N° ${data.numTicket})`,
    html: `
      <h1>Traspaso de Centro de Costo — Equipo ${data.codigo}</h1>
      <p><strong>Serie:</strong> ${data.serie} &nbsp;|&nbsp; <strong>Patente:</strong> ${data.patente}</p>
      <p><strong>Origen:</strong> ${data.ccOrigen}</p>
      <p><strong>Destino:</strong> ${data.ccDestino}</p>
      <p><strong>Fecha:</strong> ${data.fechaEntrega} &nbsp;|&nbsp; <strong>Ticket:</strong> N° ${data.numTicket}</p>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  acreditacionAprobada: (data) => ({
    subject: `Acreditación Aprobada — Carpeta ${data.numeroCarpeta}`,
    html: `
      <h1>La acreditación de la carpeta ${data.numeroCarpeta} fue <strong>Aprobada</strong>.</h1>
      <p>Equipo ${data.codigoEquipo} — Serie ${data.serie} — Patente ${data.patente}</p>
      <p>Proyecto: ${data.nombreProyecto} (${data.codigoCentro})</p>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  acreditacionRechazada: (data) => ({
    subject: `Acreditación Rechazada — Carpeta ${data.numeroCarpeta}`,
    html: `
      <h1>La acreditación de la carpeta ${data.numeroCarpeta} fue <strong>Rechazada</strong>.</h1>
      <p>Equipo ${data.codigoEquipo} — Serie ${data.serie} — Patente ${data.patente}</p>
      <p>Proyecto: ${data.nombreProyecto} (${data.codigoCentro})</p>
      <p>Gracias por usar Logitrack.</p>
      <strong>Equipo de Soporte</strong>
    `
  }),

  // Agrega más tipos...
};
